import { createGlobalStyle } from 'styled-components';

// Imported rather than written as `/assets/fonts/...`: the old webpack build
// copied src/assets to the web root, Vite does not. Importing lets Vite resolve
// the file in dev and emit a hashed copy in the build.
import OswaldLight from '../assets/fonts/Oswald-Light.woff2';
import OswaldRegular from '../assets/fonts/Oswald-Regular.woff2';
import OpenSansRegular from '../assets/fonts/OpenSans-Regular.woff2';

export const GlobalStyle = createGlobalStyle`

  @font-face {
    font-family: 'Oswald';
    src: local('Oswald'), url('${OswaldLight}') format('woff2');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'Oswald';
    src: local('Oswald'), url('${OswaldRegular}') format('woff2');
    font-weight: 400;
    font-style: normal;
  }
  @font-face {
    font-family: 'OpenSans';
    src: local('OpenSans'),  local('Open Sans'), url('${OpenSansRegular}') format('woff2');
    font-weight: 400;
    font-style: normal;
  }

  html, body {
    margin: 0;
    padding: 0;
  }

  body {
    font-family: 'OpenSans';

  }

  #root, body, html {
    height: 100%;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Oswald';
    margin: 0;
    padding: 0;
    font-weight: 400;
  }

  a, a:visited {
    text-decoration: none;
    color: inherit
  }
`;
